import { Signal } from "../core/Signal.js";

export class Resize {

    //Disable creation
    private constructor() {

    }

    public static create(...elements: Element[]): ResizeSignal {
        return new ResizeSignal(...elements);
    }
}

export class ResizeSignal extends Signal<[ResizeObserverEntry[]]> {

    private _elements: Element[] = [];

    private static _observer: ResizeObserver = null;
    private static _instances: ResizeSignal[] = [];

    constructor(...elements: Element[]) {
        super();

        ResizeSignal.createObserver();
        ResizeSignal._instances.push(this);

        this.addElements(...elements);
    }

    public get element(): Element {
        return this._elements[0];
    }

    public set element(element: Element) {

        if (this._elements[0] == element) {
            return;
        }

        if (this._elements.length > 0) {
            this.removeElements(this._elements[0]);

            if (element) {
                this.addElements(element);

                if (this._elements.length > 1) {
                    const index = this._elements.indexOf(element);
                    this._elements.splice(index, 1);
                    this._elements.unshift(element);
                }
            }

        } else {
            if (element) {
                this.addElements(element);
            }
        }
    }

    public addElements(...elements: Element[]): this {
        for (const element of elements) {

            if (!element) {
                continue;
            }

            if (this._elements.indexOf(element) === -1) {
                if (!this.isObserved(element)) {
                    ResizeSignal._observer.observe(element);
                }
                this._elements.push(element);
            }
        }

        return this;
    }

    public removeElements(...elements: Element[]): this {
        for (const element of elements) {

            if (!element) {
                continue;
            }

            const index = this._elements.indexOf(element);
            if (index !== -1) {
                this._elements.splice(index, 1);
                if (!this.isObserved(element)) {
                    ResizeSignal._observer.unobserve(element);
                }
            }
        }

        return this;
    }

    private isObserved(element: Element): boolean {
        for (const instance of ResizeSignal._instances) {
            if (instance._elements.indexOf(element) !== -1)
                return true;
        }
        return false;
    }

    public dispose(): void {
        this.removeElements(...this._elements);
        this._elements = null;
        ResizeSignal._instances.splice(ResizeSignal._instances.indexOf(this), 1);
        super.dispose();
    }

    private static createObserver(): void {
        if (this._observer)
            return;
        this._observer = new ResizeObserver((entries) => {

            const listeners: Map<ResizeSignal, ResizeObserverEntry[]> = new Map();
            for (const entry of entries) {
                for (const instance of ResizeSignal._instances) {
                    if (instance._elements.indexOf(entry.target) !== -1) {
                        if (!listeners.has(instance)) {
                            listeners.set(instance, []);
                        }
                        listeners.get(instance).push(entry);
                    }
                }
            }

            for (const listener of listeners) {
                const [signal, entries] = listener;
                signal.dispatch(entries);
            }
        });
    }
}